import { render, staticRenderFns } from "./VatRateActionDelete.vue?vue&type=template&id=00638a54&"
import script from "./VatRateActionDelete.vue?vue&type=script&lang=ts&"
export * from "./VatRateActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports